import { getRealPosition, toNode } from "@dhx/ts-common/html";
import { Navbar, createFactory, ItemType } from "@dhx/ts-navbar";
import { IMenuElement } from "./types";


type Mode = "bottom" | "right";
export class ContextMenu extends Navbar<IMenuElement> {
	protected _isContextMenu = true;

	private _mode: Mode;

	showAt(elem: HTMLElement | MouseEvent | string, showAt: Mode = "bottom") {
		if (elem instanceof MouseEvent) {
			this._changeActivePosition({
				left: window.pageXOffset + elem.x + 1,
				right: window.pageXOffset + elem.x + 1,
				top: window.pageYOffset + elem.y,
				bottom: window.pageYOffset + elem.y
			}, showAt);
		} else {
			const node = toNode(elem);
			this._changeActivePosition(getRealPosition(node), showAt);
		}

	}
	protected _getFactory() {
		return createFactory({
			widget: this,
			defaultType: ItemType.menuItem,
			allowedTypes: [
				ItemType.menuItem,
				ItemType.spacer,
				ItemType.separator,
				ItemType.customHTML,
				// TODO: deprecated
				ItemType.customHTMLButton
			],
			widgetName: "context-menu"
		});
	}
	protected _close(e: MouseEvent): void {
		super._close(e);
		this._activeMenu = null;
		this._changeActivePosition(null, null);
	}
	protected _getMode(_item, _root, active: boolean): Mode {
		return active ? this._mode : "right";
	}
	private _changeActivePosition(position, mode: Mode) {
		this._activePosition = position;
		this._mode = mode;
		this._listenOuterClick();
		this.paint();
	}
}